
<template>
    <div v-if="!isCookieAccepted" class="cookie-popup">
        <div class="cookie-content">
            <div class="cookie-text">
                <p>הפרטיות שלכם חשובה לנו. לידיעתכם, באתר זה נעשה שימוש בקבצי "עוגיות" (cookies) וכלים דומים במטרה לשפר את חווית הגלישה, לספק תוכן מותאם אישית ולבצע ניתוחים סטטיסטיים. למידע נוסף ניתן לעיין ב<a href="/privacy.html" target="_blank" class="privacy-link">מדיניות הפרטיות</a></p>
            </div>
            <button @click="acceptCookies" class="accept-btn">הבנתי</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookiePopup',

    data() {
        return {
            isCookieAccepted: false,
        }
    },
    created() {
        this.checkCookieStatus();
    },
    methods: {
        checkCookieStatus() {
            const cookies = document.cookie.split(';');
            const cookieAccepted = cookies.find(cookie => 
                cookie.trim().startsWith('cookieAccepted=')
            );
            this.isCookieAccepted = cookieAccepted && cookieAccepted.includes('true');
        },
        
        acceptCookies() {
            // Set cookie with expiration date (1 year from now)
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            
            document.cookie = `cookieAccepted=true; expires=${expirationDate.toUTCString()}; path=/`;
            this.isCookieAccepted = true;
        }
    }
}
</script>

<style scoped lang="less">
.cookie-popup {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #00a69c;
    color: white;
    z-index: 1000;

    .cookie-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1400px;
        margin: 0 auto;
        gap: 20px;
        padding: 15px 20px;
        direction: rtl;

        .cookie-text {
            flex: 1;
            
            p {
                margin: 0;
                font-size: 14px;
                line-height: 1.5;
                color: white;
                
                .privacy-link {
                    color: white;
                    text-decoration: underline;
                    cursor: pointer;
                    
                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }

        .accept-btn {
            background: white;
            color: #333;
            border: none;
            padding: 10px 20px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            white-space: nowrap;
            transition: all 0.2s ease;
            min-width: 80px;

            &:hover {
                background: #f5f5f5;
                transform: translateY(-1px);
            }

            &:active {
                transform: translateY(0);
            }
        }
    }
}

@media (max-width: 768px) {
    .cookie-popup {
        padding: 12px 15px;
        
        .cookie-content {
            flex-direction: column;
            gap: 15px;
            text-align: center;
            
            .cookie-text {
                p {
                    font-size: 13px;
                }
            }
            
            .accept-btn {
                width: 100%;
                max-width: 120px;
            }
        }
    }
}

@media (max-width: 480px) {
    .cookie-popup {
        .cookie-content {
            .cookie-text {
                p {
                    font-size: 12px;
                }
            }
        }
    }
}
</style>